import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";
import { AdjustBanner, useShouldLoadAdjust } from "./AdjustBanner";
import { CustomBanner, useShouldLoadCustomBanner } from "./CustomBanner";
import { IOSBanner } from "./IOSBanner/IOSBanner";
/**
 * AppBanner component that displays different App banners based on the user's device.
 *
 * The native iOS Smart App Banner (<meta name="apple-itunes-app">) is always rendered to reduce layout shifts (CLS – Cumulative Layout Shift).
 * This only affects Safari on iOS, so there's no need to conditionally hide it.
 *
 * Custom banners (e.g., Adjust) are disabled when iOS Safari is detected to prevent showing multiple banners at once.
 */
export const AppBanner = () => {
    const { isWebView } = useEnvironment();
    const shouldLoadAdjust = useShouldLoadAdjust();
    const shouldLoadCustomBanner = useShouldLoadCustomBanner();
    if (isWebView)
        return null;
    if (shouldLoadCustomBanner)
        return _jsx(CustomBanner, {});
    return (_jsxs(_Fragment, { children: [_jsx(IOSBanner, {}), shouldLoadAdjust && _jsx(AdjustBanner, {})] }));
};
